/*! facett renewal — gift points swiper（横長カード＋覗き見） */
(function () {
  var CSS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  var JS_SRC = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve();
    var existing = document.querySelector('script[data-facett-swiper]');
    if (existing) {
      return new Promise(function (resolve) {
        existing.addEventListener('load', function () {
          resolve();
        });
        if (window.Swiper) resolve();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-facett-swiper', '1');
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function getPager(root) {
    return root ? root.querySelector('[data-facett-gift-points-pagination]') : null;
  }

  function clearPager(root) {
    var pager = getPager(root);
    if (!pager) return;
    pager.innerHTML = '';
  }

  function syncPager(root, swiper) {
    var pager = getPager(root);
    if (!pager || !swiper) return;
    var count = swiper.slides ? swiper.slides.length : 0;
    if (count < 2) {
      clearPager(root);
      return;
    }
    if (pager.children.length !== count) {
      pager.innerHTML = '';
      for (var i = 0; i < count; i++) {
        (function (idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'facett-gift-points__bullet';
          btn.setAttribute('aria-label', 'ポイント ' + (idx + 1));
          btn.addEventListener('click', function () {
            swiper.slideTo(idx);
          });
          pager.appendChild(btn);
        })(i);
      }
    }
    var active = swiper.realIndex || 0;
    Array.prototype.forEach.call(pager.children, function (el, i) {
      el.classList.toggle('is-active', i === active);
    });
  }

  function destroyPoints(root) {
    if (!root) return;
    if (root._facettGpSwiper && typeof root._facettGpSwiper.destroy === 'function') {
      try {
        root._facettGpSwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    }
    root._facettGpSwiper = null;
    clearPager(root);
  }

  function initPoints(root) {
    if (!root) return;
    var el = root.querySelector('[data-facett-gift-points-swiper]');
    if (!el) return;

    destroyPoints(root);

    var slides = el.querySelectorAll('.swiper-slide');
    var count = slides.length;
    if (count <= 0) return;
    if (!window.Swiper) return;

    /* 1枚のみ: スライダー不要 */
    if (count === 1) {
      return;
    }

    root._facettGpSwiper = new window.Swiper(el, {
      loop: false,
      speed: 450,
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: false,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: true,
        },
      },
      on: {
        init: function (swiper) {
          syncPager(root, swiper);
        },
        slideChange: function (swiper) {
          syncPager(root, swiper);
        },
      },
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-facett-gift-points]').forEach(function (root) {
      initPoints(root);
    });
  }

  function anyNeedsSwipe() {
    var roots = document.querySelectorAll('[data-facett-gift-points]');
    return Array.prototype.some.call(roots, function (root) {
      var el = root.querySelector('[data-facett-gift-points-swiper]');
      if (!el) return false;
      return el.querySelectorAll('.swiper-slide').length > 1;
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-facett-gift-points]');
    if (!roots.length) return;

    if (anyNeedsSwipe()) {
      Promise.all([loadStylesheet(CSS_HREF), loadScript(JS_SRC)])
        .then(function () {
          window.requestAnimationFrame(syncAll);
        })
        .catch(function () {
          syncAll();
        });
      return;
    }

    syncAll();
  }

  var resizeTimer = null;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(boot, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-facett-gift-points]')) {
      boot();
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector('[data-facett-gift-points]');
    if (root) destroyPoints(root);
  });
})();
